/**
 *
 * Card
 *
 */

import React from 'react';

import styled from 'styled-components';
import "./layout.scss";

const Container = styled.div`

`

/* eslint-disable react/prefer-stateless-function */
export const Card = function(props){

    let classNames = ['card', props.className || ''];

    return (
      <Container className={classNames.join(' ')}>
        {props.children}
      </Container>
    );
}

